import {AxiosError, HttpStatusCode} from 'axios';

export const isForbiddenError = (error: unknown): boolean => {
  return error instanceof AxiosError && error.response?.status === HttpStatusCode.Forbidden;
};

export const isNotFoundError = (error: unknown): boolean => {
  return error instanceof AxiosError && error.response?.status === HttpStatusCode.NotFound;
};
